<template>
    <global-modal v-model="isOpened" width="480px">
        <div class="confirm-modal">
            <h4 class="confirm-modal-headline">{{ config.message }}</h4>
            <div v-if="config.subject" class="confirm-modal-subject">
                <img v-if="config.image !== undefined"
                     :class="['confirm-modal-thumb', {'is-placeholder': !config.image}]"
                     :src="config.image || '/gfx/cart/noimage.svg'"
                     width="48" height="48" alt="">
                <span class="confirm-modal-subject-name">{{ config.subject }}</span>
            </div>
            <div class="confirm-modal-actions">
                <button class="btn btn-secondary small" type="button" @click="isOpened = false">
                    {{ config.cancel }}
                </button>
                <button class="btn btn-primary small" type="button" @click="confirm">
                    {{ config.submit }}
                </button>
            </div>
        </div>
    </global-modal>
</template>

<script setup lang="ts">
import {GlobalModal} from '@webstacz/shop-components';
import {reactive, ref} from 'vue';

export type ConfirmConfig = {
    message: string;
    submit: string;
    cancel: string;
    subject?: string;
    image?: string;
    onConfirm: () => void;
};

const config = reactive<ConfirmConfig>({
    message: '',
    submit: '',
    cancel: '',
    onConfirm: () => {},
});

const isOpened = ref(false);

const confirm = (): void => {
    isOpened.value = false;
    config.onConfirm();
};

window.openConfirmModal = (modalConfig: ConfirmConfig): void => {
    Object.assign(config, {subject: undefined, image: undefined}, modalConfig);
    isOpened.value = true;
};
</script>

<style scoped lang="scss">
.confirm-modal-headline {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    margin: 0 24px 20px 0;
}

.confirm-modal-subject {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 28px;
    padding: 12px 14px;
    background: #fafafa;
    border: 1px solid #f0f0f0;
}

.confirm-modal-thumb {
    flex: 0 0 auto;
    width: 48px;
    height: 48px;
    object-fit: contain;
    background: #fff;
    border: 1px solid #f0f0f0;

    &.is-placeholder {
        padding: 10px;
    }
}

.confirm-modal-subject-name {
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    overflow-wrap: anywhere;
}

.confirm-modal-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;

    .btn {
        width: 100%;
        padding-left: 16px;
        padding-right: 16px;
    }
}
</style>
